exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".img_box_1ef9907{width:120px;height:120px;overflow:hidden;position:relative;border-radius:4px;border:1px solid #f0f2f8;border:solid 1px var(--color-border);display:inline-block;margin-left:10px}.img_box_1ef9907 img{max-width:100%;height:100%;min-width:100%;cursor:pointer}.img_box_1ef9907 .action_c81e86e{position:absolute;left:0;right:0;bottom:-100%;line-height:24px;text-align:center;color:#fff;background:rgba(0,0,0,.3);transition:bottom .3s ease-out}.img_box_1ef9907:hover .action_c81e86e{bottom:0;transition:bottom .3s linear}.img_box_1ef9907 .action_c81e86e .iconfont{cursor:pointer}", ""]);

// exports
exports.locals = {
	"img_box": "img_box_1ef9907",
	"action": "action_c81e86e"
};